/**
 * Swym Wishlist API wrapper.
 * Isolates third-party Swym errors from crashing the application.
 * Attaches to window.SwymWrapper for use without ES modules.
 */
(function () {
  'use strict';

  function isSwymReady() {
    return !!(window._swat && typeof window._swat.fetchWrtEventTypeET === 'function');
  }

  function getSwym() {
    return isSwymReady() ? window._swat : null;
  }

  function waitForSwym(timeout) {
    timeout = timeout || 15000;
    return new Promise(function (resolve, reject) {
      if (isSwymReady()) {
        resolve(window._swat);
        return;
      }
      var startTime = Date.now();
      function checkSwym() {
        var elapsed = Date.now() - startTime;
        if (isSwymReady()) {
          resolve(window._swat);
        } else if (elapsed > timeout) {
          reject(new Error('Swym failed to initialize within timeout period'));
        } else {
          setTimeout(checkSwym, 100);
        }
      }
      checkSwym();
    });
  }

  function fetchWishlistItems(callback, onError) {
    try {
      var swat = getSwym();
      if (!swat) {
        callback([]);
        return;
      }
      var eventType = (swat.EventTypes && (swat.EventTypes.addToWishlist != null ? swat.EventTypes.addToWishlist : swat.EventTypes.addedToWishlist)) || 1;
      swat.fetchWrtEventTypeET(function (items) {
        try {
          callback(items || []);
        } catch (err) {
          if (onError) onError(err);
        }
      }, eventType);
    } catch (err) {
      callback([]);
      if (onError) onError(err);
    }
  }

  function fetchListDetails(lid, callback, onError) {
    try {
      var swat = getSwym();
      if (!swat) {
        if (onError) onError(new Error('Swym not ready'));
        return;
      }
      swat.fetchListDetails({ lid: lid }, callback, function (err) {
        if (onError) onError(err);
      });
    } catch (err) {
      if (onError) onError(err);
    }
  }

  function fetchCustomerLists(callback, onError) {
    try {
      var swat = getSwym();
      if (!swat || typeof swat.fetchLists !== 'function') {
        callback([]);
        return;
      }
      swat.fetchLists({
        callbackFn: function (lists) {
          try {
            callback(lists || []);
          } catch (err) {
            if (onError) onError(err);
          }
        },
        errorFn: function (err) {
          callback([]);
          if (onError) onError(err);
        }
      });
    } catch (err) {
      callback([]);
      if (onError) onError(err);
    }
  }

  window.SwymWrapper = {
    isSwymReady: isSwymReady,
    getSwym: getSwym,
    waitForSwym: waitForSwym,
    fetchWishlistItems: fetchWishlistItems,
    fetchListDetails: fetchListDetails,
    fetchCustomerLists: fetchCustomerLists
  };
})();
